import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';

export default function DataGridTable({
  ImgPath,
  rows,
  totalRowCount,
  isLoading,
  paginationModel,
  setPaginationModel,
  handleOpen,
  setSelectedRows,
}) {
  // const [paginationModel, setPaginationModel] = useState({
  //   page: 0,
  //   pageSize: 10,
  // });
  // const queryOptions = useMemo(
  //   () => ({ ...paginationModel }),
  //   [paginationModel]
  // );

  /* useEffect(() => {
   // let active = true;
   console.log(paginate.page+ 1);
   setPaginate(old => ({ ...old, page: paginate.page+ 1 }))
   //  setIsLoading(true);
   //  fetchRentData(queryOptions).then(({ rows, pageInfo }) => {
   //    if (!active) {
   //      return;
   //    }
   //    setRows(rows);
   //    setTotalRowCount(pageInfo.totalRowCount);
   //    setIsLoading(false);
   //  });

   //  return () => {
   //    active = false;
   //  };
  }, [queryOptions]);*/

  const columns = [
    {
      field: 'RentalDate',
      headerName: 'วันที่เก็บค่าเข่า',
      width: 120,
      // flex: 1,
    },
    {
      field: 'BlockNumber',
      headerName: 'เลขที่บล็อก',
      width: 80,
      // flex: 1/2,
    },
    {
      field: 'ImgShop',
      headerName: 'ภาพหน้าร้าน',
      width: 100,
      align: 'center',
      // flex: 1,
      renderCell: (params) => (
        <img
          src={ImgPath + params.value}
          alt="Shop"
          style={{
            borderRadius: '0.375rem',
            width: '59px',
            height: '59px',
          }}
          onClick={() => handleOpen(ImgPath + params.value)}
        />
      ),
    },
    {
      field: 'tenantName',
      headerName: 'ชื่อผู้เช่า',
      // width: 70 ,
      flex: 1,
    },
    {
      field: 'Business',
      headerName: 'ประเภทธุรกิจ',
      flex: 1,
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                borderRadius: '3px',
                height: '14px',
                width: '14px',
                backgroundColor: params.row.color,
                marginRight: '6px',
              }}
            />
            <div style={{ fontWeight: 500 }}>{params.value}</div>
          </div>
        );
      },
    },
    {
      field: 'TentDeposit',
      headerName: 'ค่ามัดจำเต็นท์',
      // width: 70,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <p>
              {params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </p>
          </>
        );
      },
    },
    {
      field: 'Rent',
      headerName: 'ค่าเช่า',
      // width: 70 ,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <p>
              {params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </p>
          </>
        );
      },
    },
    {
      field: 'ExpOverdue',
      headerName: 'คงค้าง',
      // width: 70 ,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <p>
              {params.value === null
                ? params.row.ReceiptOverdue.toString().replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ','
                  )
                : params.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </p>
          </>
        );
      },
    },
    {
      field: '',
      headerName: 'ยอดรวมที่ต้องเก็บ',
      // width: 70 ,
      flex: 1,
      renderCell: (params) => {
        let Rent = params.row.Rent;
        let Own =
          params.row.ExpOverdue === null
            ? params.row.ReceiptOverdue
            : params.row.ExpOverdue;
        let Fine = params.row.fines;
        const TotalBePaid = Rent + Own + Fine;
        return (
          <>
            <p>
              {TotalBePaid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </p>
          </>
        );
      },
    },
    {
      field: 'NumberRentalDays',
      headerName: 'จำนวนวันรอบบิล',
      // width: 70,
      flex: 1,
      align: 'center',
      renderCell: (params) => {
        return (
          <>
            <p>{params?.value || '--/--/--'}</p>
          </>
        );
      },
    },
    {
      field: 'status_pay',
      headerName: 'สถานะการจ่าย',
      // width: 70,
      flex: 1,
      renderCell: (params) => {
        let Status = params.value === 1 ? 'จ่ายแล้ว' : 'ยังไม่จ่าย';
        return (
          <>
            <p
              style={{ color: Status === 'ยังไม่จ่าย' ? '#FF2C2C' : '#00D715' }}
            >
              {Status}
            </p>
          </>
        );
      },
    },
    {
      field: 'slip',
      headerName: 'หลักฐานการจ่าย',
      // width: 70,
      flex: 1,
      align: 'center',
      renderCell: (params) => (
        <img
          src={ImgPath + params.value}
          alt="Shop"
          style={{
            borderRadius: '0.375rem',
            width: '59px',
            height: '59px',
          }}
          onClick={() => handleOpen(ImgPath + params.value)}
        />
      ),
    },
  ];

  const onRowsSelectionHandler = (ids) => {
    console.log(ids);
    const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
    console.log(selectedRowsData);
    setSelectedRows(selectedRowsData);
  };

  // console.log(paginate);

  return (
    <Paper sx={{ width: '100%' }}>
      <DataGrid
        rowHeight={70}
        columns={columns}
        rows={rows}
        rowCount={totalRowCount}
        loading={isLoading}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        sortingMode="server"
        //   onPageChange={(newPage) => {
        //    setPageState(old => ({ ...old, page: newPage + 1 }))
        //     console.log(newPage + 1);
        //   }}
        //   sortModel={sortModel}
        //   pagination
        //   onFilterModelChange={setFilterModel}
        // pageSizeOptions={[10, 25, 50]} // เพิ่มตัวเลือก pageSize ตามต้องการ
        checkboxSelection
        onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
        autoPageSize
        className="custom-data-grid"
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
      />
    </Paper>
  );
}
